import isArrayEmpty from './isArrayEmpty';
import areGradeTypesPercentage from './areGradeTypesPercentage';
import areWeightagesFilled from './areWeightagesFilled';
import getTotalWeight from './getTotalWeight';

const EXPECTED_TOTAL_WEIGHT = 100;

const validateAssignments = ({
  selectedAssignments,
  selectedAssignmentDetails,
}) => {
  // in case no assignment is mapped
  if (isArrayEmpty(selectedAssignments)) {
    return {
      isAssignmentButtonDisabled: true,
      isMultiple: false,
      valid: true, // allow to map empty array to assessment item
    };
  }

  // in case of assignment(s) is removed from backend
  if (selectedAssignments.length !== selectedAssignmentDetails.length) {
    return {
      isAssignmentButtonDisabled: true,
      isMultiple: selectedAssignments.length > 1,
      valid: false,
    };
  }

  // in case one assignment is mapped
  // if only one assignment can be mapped (e.g. freeform)
  // we disable the button and show a tooltip
  if (selectedAssignments.length === 1) {
    return {
      isAssignmentButtonDisabled: !areGradeTypesPercentage(
        selectedAssignmentDetails
      ),
      isMultiple: false,
      valid: true,
    };
  }

  // in case more than one assignment are mapped
  // - they must be all percentage
  // - the total weightage must be 100%
  // - all the weightage fields must be filled in
  const areAllPercentage = areGradeTypesPercentage(selectedAssignmentDetails);
  const totalWeightage = getTotalWeight(selectedAssignments);
  const areFilled = areWeightagesFilled(selectedAssignments);

  return {
    isAssignmentButtonDisabled: !areAllPercentage,
    isMultiple: true,
    valid:
      areAllPercentage && areFilled && totalWeightage === EXPECTED_TOTAL_WEIGHT,
  };
};

export default validateAssignments;
